import { render, staticRenderFns } from "./RespiratorPneumonia.vue?vue&type=template&id=bbf8a156&scoped=true"
import script from "./RespiratorPneumonia.vue?vue&type=script&lang=js"
export * from "./RespiratorPneumonia.vue?vue&type=script&lang=js"
import style0 from "./RespiratorPneumonia.vue?vue&type=style&index=0&id=bbf8a156&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf8a156",
  null
  
)

export default component.exports